import DataSource from 'devextreme/data/data_source';
import MatchingConnector from "@/components/matching/MatchingConnector";
import {RemoteOperations} from "@/types/RemoteOperations";
import {ResultPage} from "@gipa/devextreme-to-spring";
import {Matching} from "@/types/Matching";

export class MatchingDataSource extends DataSource {

    constructor() {
        super({
            load: function (loadOptions): Promise<ResultPage<Matching>>  {
                return MatchingConnector.getInstance().filter(loadOptions);
            }
        });
    }
}

export const sortOptions: any = {
    avalId: "avalID",
    status: "avalState",
    customer: "client.contractPartner",
    material: "client.material",
    container: "client.containerType",
    date: "requestedOn"
};
export const remoteOperations: RemoteOperations = {
    paging: true,
    sorting: true,
    filtering: true,
};